export default __webpack_public_path__ + "static/media/dancing.3417856c.mp4";